import { Select } from "../../../ui/select/select";
import { Input } from "../../../ui/input/input";
import { Button } from "../../../ui/button/button";
import { Header } from "../../../ui/header/header";
import "./print-order-create.scss";
import { PrintLabeledUI } from "./component/print-labeled-ui";
import { PrintItemSelect } from "./component/item-select.print";
import { PrintItemSetting } from "./component/print-item-setting";
import { useCreatePrintOrder } from './hooks/use-create-print-order';
import iconReturn from '../../../../assets/img/icon/return.svg';
import iconSave from '../../../../assets/img/icon/save.svg';
import { SelectPrintCard } from "./component/select-print-card";
import { usePrintStatus } from "../hooks/use-print-status";
const nextButtonStyle = {
  width: '140px',
}
export const PrintOrderCreate = () => {
  const {
    categories,
    processing,
    word,
    search,
    printItems,
    itemSetting,
    onClickSave,
    onClickNext,
    additionalList,
    onClickReturnItemSelect,
    handlerClickFinish,
    status,
    loadFavoriteItem,
    LoadingPopup,
    isSizeAdd,
  } = useCreatePrintOrder();
  usePrintStatus({ isLockedAfterOrder: true });
  return status === 'select' ? (
    <div className="column_direction_wrap">
      <Header />
      <div className="print_create_order">
      <div className="create_order__menu">
          <div>
            <Button
              label="保存しないで終了"
              icon={<img
                src={iconReturn}
                alt=""
              />}
              onClick={handlerClickFinish}
              color="light"
            />
          </div>
          <div>
            <div className="helped_btn">
              <Button
                label="お気に入り商品読み込み"
                onClick={loadFavoriteItem}
              />
            </div>
            <div className="flex_box gap_6">
              <Button
                label="次へ進む"
                color="warning"
                style={nextButtonStyle}
                onClick={onClickNext}
                disabled={printItems.selectId === ''}
              />
            </div>
          </div>
        </div>

        <div className="print_create_order__category">
          <div className="search_print_order">
            <div className="bottom_border_header search_print_order__header">
              商品情報
            </div>
            {!isSizeAdd ? (
              <>
                <PrintLabeledUI label="カテゴリー">
                  <Select {...categories} />
                </PrintLabeledUI>
                <PrintLabeledUI label="加工" hidden={!categories.value || !processing.list.length}>
                  <Select {...processing} addEmpty />
                </PrintLabeledUI>
              </>
            ) : (
              <PrintLabeledUI label="カテゴリー">
              <div>{categories.list.find((v) => v.value === categories.value)?.label ?? ''}</div>
              </PrintLabeledUI>
            )}
            <PrintLabeledUI label="キーワード">
              <Input {...word} />
            </PrintLabeledUI>
            <div className="search_print_order__footer">
              <Button label="検索" icon={<i className="fas fa-search" />} {...search} />
            </div>
            <PrintItemSelect {...printItems }/>
            {/* <PrintItemSetting {...itemSetting} /> */}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="column_direction_wrap">
      <Header />
      <div className="print_create_order">
        <div className="create_order__menu">
          <div>
            <Button
              label="保存しないで終了"
              icon={<img
                src={iconReturn}
                alt=""
              />}
              onClick={handlerClickFinish}
              color="light"
            />
          </div>
          <div>
            <div className="helped_btn">
              <Button
                label="商品選択に戻る"
                onClick={onClickReturnItemSelect}
              />
            </div>
            <div className="flex_box gap_6">
              <Button
                label="保存して次へ"
                color="warning"
                icon={<img
                  src={iconSave}
                  alt=""
                />}
                style={nextButtonStyle}
                onClick={onClickSave}
              />
            </div>
          </div>
        </div>
        <div className="print_create_order__category">
          <div className="search_print_order">
            <div className="bottom_border_header search_print_order__header">
              商品情報
            </div>
            <SelectPrintCard
              data={printItems.productList.find((v) => v.productNameId === printItems.selectId)}
              callback={(info) => {}}
              isSelect={false}
              unSelectable
            />
            <PrintItemSetting {...itemSetting} additional={additionalList} />
          </div>
        </div>
      </div>
      <LoadingPopup />
    </div>
  );
}